<script setup lang="ts">
import { RunningDotVariant } from './types';
import type { RunningDotVariantValue } from './types';

defineOptions({ inheritAttrs: false });

withDefaults(defineProps<{
    variant?: RunningDotVariantValue;
}>(), {
    variant: RunningDotVariant.Active,
});
</script>

<template>
    <!-- Running states: Tag's word carries the meaning, per Studio 0008 and 0016. -->
    <span
        v-bind="$attrs"
        class="running-dot"
        :class="`running-dot--${variant}`"
        aria-hidden="true"
    />
</template>

<style scoped>
.running-dot {
    display: inline-block;
    flex-shrink: 0;
    width: var(--app-space-8);
    height: var(--app-space-8);
    border-radius: var(--app-radius-xl);
    background: var(--app-success);
}

/* Running states: only a reading that updates in place pulses. */
.running-dot--live {
    /* Circuit has no motion token. */
    --auctions-status-dot-pulse-duration: 2s;
    animation: auctions-status-dot-pulse var(--auctions-status-dot-pulse-duration) ease-in-out infinite;
}

/* Running states: the dot stays visible throughout the pulse. */
@keyframes auctions-status-dot-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: var(--app-disabled);
    }
}

/* Running states: reduced motion keeps the same steady indicator. */
@media (prefers-reduced-motion: reduce) {
    .running-dot--live {
        animation: none;
    }
}
</style>
